import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const Navbar = ({ onMenuClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const isAuthenticated = !!localStorage.getItem("token");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Only show navbar on mobile and tablet (not desktop)
  if (isDesktop) {
    return null;
  }

  return (
    <AppBar
      position="fixed"
      sx={{
        top: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(12px)',
        boxShadow: scrolled ? '0 4px 20px rgba(0,0,0,0.06)' : 'none',
        borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
        zIndex: 1300,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
      elevation={0}
    >
      <Toolbar 
        sx={{ 
          px: { xs: 2, sm: 3 },
          minHeight: { xs: '64px', sm: '72px' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Left: Menu Icon */}
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onMenuClick}
          sx={{ 
            color: 'text.primary',
            backgroundColor: 'rgba(0,0,0,0.02)',
            borderRadius: '12px',
            p: 1,
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.05)',
            }
          }}
        >
          <MenuIcon />
        </IconButton>

        {/* Center: Brand */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            flex: 1,
            justifyContent: 'center',
            ml: -2, // Offset to compensate for left button
          }}
        >
          <Box
            component="img"
            src="/pink_logo.png"
            alt="Ishqnama art Logo"
            sx={{
              height: { xs: 32, sm: 36 },
              width: 'auto',
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.05))',
            }}
          />
          <Box
            component="img"
            src="/namelogo.png"
            alt="Ishqnama art Name"
            sx={{
              height: { xs: 24, sm: 28 },
              width: 'auto',
            }}
          />
        </Box>

        {/* Right: Empty to balance center logo */}
        <Box sx={{ width: 40 }} />
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
